// extracted by mini-css-extract-plugin
export default {"msgM":"_0761cf7ba0"};